<template>
  <div>

    <v-navigation-drawer   width="260" :clipped="clipped" v-model="val"
 fixed="" app>
      <v-list dense>
        <template v-for="item in items">

          <v-list-group v-if="item.items" :key="item.title" :prepend-icon="item.icon" no-action>
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title> {{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <template v-for="(subItem, i) in item.items">
              <!--sub group-->
              <v-list-group v-if="subItem.items" :group="subItem.group" sub-group="sub-group" :key="subItem.title">
                <v-list-tile slot="activator" ripple="ripple">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <template v-for="(grand, i) in subItem.items" ripple="ripple">
                  <v-list-group v-if="grand.items" :group="grand.group" sub-group="grand-group" :key="grand.title">
                    <v-list-tile slot="activator" ripple="ripple">
                      <v-list-tile-content>
                        <v-list-tile-title>{{ grand.title }}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <template v-for="(gsub, i) in grand.items" ripple="ripple">
                      <v-list-tile :key="i" :to="{ name: gsub.to }">
                        <v-list-tile-content>
                          <v-list-tile-title>{{ gsub.title }}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </template>
                  </v-list-group>
                  <!--child item-->
                  <v-list-tile v-else :key="i" :to="{ name: grand.to }">
                    <v-list-tile-content>
                      <v-list-tile-title>{{ grand.title }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-list-group>

              <!--child item-->
              <v-list-tile v-else :key="i" :disabled="subItem.disabled" :target="subItem.target" ripple="ripple" :to="{ name: subItem.to }">
                <v-list-tile-content>
                  <v-list-tile-title>
                    <span>{{ subItem.title }}</span>
                  </v-list-tile-title>
                </v-list-tile-content>
                <v-chip class="white--text pa-0 chip--x-small" v-if="subItem.badge" color="primary" disabled="disabled">{{
                  subItem.badge }}</v-chip>
                <v-list-tile-action v-if="subItem.action">
                  <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list-group>

          <v-list-tile v-else :key="item.title" :to="!item.href ? { name: item.to } : null" :href="item.href">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.title }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>


        </template>
        <v-list-tile @click="logout()">
          <v-list-tile-action>
            <v-icon>power_settings_new</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              {{$t('Log-Out')}}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

  </div>
</template>


<script>
  import auth from '../../../api/auth'


  export default {
   props: ["value"],
    computed: {
  val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },

    beforeMount: beforeMount,
    watch: {

    },
    methods: {
      logout() {
        auth.logout()
      }
    },
    data() {
      return {
        clipped: true,
        fixed: false,
        miniVariant: false,
        right: true,
        rightDrawer: false,

        items: [{
            icon: 'business',
            title: this.$t('Login'),
            to: 'anasirket',

          },
          {
            icon: 'shopping_cart',
            title: this.$t('Buy-Products'),
            to: 'urunsatis',
             href: '/#/account/urunler/id'
          },
          {
            icon: 'people',
            title: this.$t('Member-Transactions'),
            group: 'uye',
            color: 'blue darken-2',
            items: [{
                title: this.$t('Member-List'),
                to: 'login-uye',
              },
              {
                title: this.$t('Authority-Groups'),
                to: 'login-yetkigruplist',
              },
            ]

          },
          // {
          //   icon: 'payment',
          //   title: 'Ödeme',
          //   to: 'urunsatinal',

          // },
        ],

      }
    },


  }






  function beforeMount() {

  }
</script>